// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionLRC_TheComp__0ULlv"};